import { useEffect } from 'react';
import React from 'react';
import { useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Spin, Button, Card, Timeline, message, Modal } from 'antd';

import Conf from '../../../Configurazione';
import sessionManager, { eVariableType } from '../../../SessionManager';
import api from '../../../api';
import stringres from '../../../translations/stringres';
import EventoCliente from './EventoCliente';
import EventoClienteAddEdit from './EventoClienteAddEdit';

export default function EventiCliente(props) {
    const { codCliente } = props;
    const configurazione = Conf();

    const [openAddEdit, setOpenAddEdit] = useState(false);
    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [eventi, setEventi] = useState(null);
    const [reload, setReload] = useState(false);

    useEffect(() => {
        async function loadEventi() {
            try {
                setIsLoadingSave(true);

                const result = await api.get(
                    'CRM/Clienti/EventiCliente?idSocieta=' +
                        sessionManager.get(eVariableType.IDSocieta) +
                        '&codCliente=' +
                        codCliente
                );

                if (result != null && result.data != null) {
                    setEventi(result.data);
                } else {
                    message.error(result.statusTextat);
                }
            } catch (error) {
                message.error(error.message, 5);
            } finally {
                setIsLoadingSave(false);
            }
        }

        loadEventi();
    }, [reload, configurazione.apiBaseUrl, codCliente]);

    function onClickAddEvento() {
        setOpenAddEdit(true);
    }

    function GetColor(item) {
        const dscad = new Date(item.dataScadenza).getTime();

        if (item.idTipoEvento === 2) return 'gray';
        if (dscad === 0) return 'green';

        if (Date.now() >= dscad) return 'red';
        else return 'green';
    }

    function funcreload() {
        setReload(!reload);
    }
    function conferma(e) {
        setOpenAddEdit(false);
        if (e) setReload(!reload);
    }

    const itemsTimeline = eventi
        ? eventi.map((item) => ({
              key: item.idEvento,
              color: GetColor(item),
              children: <EventoCliente item={item} reload={funcreload} />,
          }))
        : [];

    return (
        <div>
            <Spin spinning={isLoadingSave}>
                <Card
                    title={stringres.t('eventiCliente')}
                    extra={
                        <Button onClick={onClickAddEvento}>
                            <PlusOutlined />
                        </Button>
                    }
                >
                    <Timeline items={itemsTimeline}></Timeline>
                </Card>
                <Modal
                    destroyOnClose="true"
                    title={stringres.t('eventoaddedit')}
                    open={openAddEdit}
                    onCancel={() => setOpenAddEdit(false)}
                    footer={null}
                >
                    <EventoClienteAddEdit codCliente={codCliente} confirm={conferma}></EventoClienteAddEdit>
                </Modal>
            </Spin>
        </div>
    );
}
